import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

export function StatCard({ title, value, icon, trend }) {
  return (
    <div className="rounded-lg border border-border bg-card text-card-foreground shadow-sm">
      <div className="p-6">
        <div className="flex items-center justify-between space-x-4">
          <div className="flex-1 space-y-1">
            <p className="text-sm font-medium text-muted-foreground">{title}</p>
            <p className="text-2xl font-bold text-foreground">{value.toLocaleString()}</p>
            {trend && (
              <div className="flex items-center gap-1 text-xs">
                {trend.isPositive ? (
                  <TrendingUp className="h-3 w-3" style={{ color: '#547a84' }} />
                ) : (
                  <TrendingDown className="h-3 w-3" style={{ color: '#f0856d' }} />
                )}
                <span style={{ color: trend.isPositive ? '#547a84' : '#f0856d' }}>
                  {trend.value}%
                </span>
                <span className="text-muted-foreground">vs last week</span>
              </div>
            )}
          </div>
          {/* Icon circle uses coral tint */}
          <div
            className="flex h-12 w-12 items-center justify-center rounded-full"
            style={{ background: 'rgba(240,133,109,0.12)', color: '#f0856d' }}
          >
            {icon}
          </div>
        </div>
      </div>
    </div>
  );
}